import { Blockquote, Text } from "@radix-ui/themes";
import AddBottomSpace from "../../components/AddBottomSpace";
import AddHeadline from "../../components/AddHeadline";
import AddTopSpace from "../../components/AddTopSpace";

export default function Impressum() {

  return (
    <>
      <AddTopSpace />
      <AddHeadline />
      <div className="container">

      <div className='row'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="8" color>
                    Impressum
                  </Blockquote>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div className='row'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>

                  <Text as="p" mb="5" size="4">
                    Angaben gemäß § 5 DDG<br/>
                    Adrian Navigante<br/>
                    Baslerstrasse 115<br/>
                    79115 Freiburg im Breisgau
                    <br/><br/>
                    <b>Vertreten durch:</b><br/>
                    Adrian Navigante<br/><br/>
                    <b>Kontakt:</b><br/> 
                    <b>Telefon:</b> 0049 17613637834 / 0049 17647664552<br/>
                    <b>E-Mail:</b> intersticesctt@gmail.com<br/><br/>
                    <b>Umsatzsteuer-ID:</b> <br/>
                    Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz: 1576 1082 1219 001<br/>
                    <b>Wirtschafts-ID:</b><br/>
                    <b>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</b><br/>
                    Adrian Navigante<br/>
                    Baslerstrasse 115<br/>
                    79115 Freiburg im Breisgau<br/><br/>

                    <b>Haftungsausschluss:</b><br/> 
                    <b>Haftung für Inhalte</b><br/>
                    Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                    <br/><br/>
                    <b>Haftung für Links</b>
                    <br/>
                    Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                    <br/><br/>
                    <b>Urheberrecht</b><br/>
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                    <br/><br/>
                    <b>
                      Datenschutz
                    </b>
                    <br/>
                    Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder eMail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.
                    <br/><br/>
                    Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.



                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>


        



      </div>
      
      <AddBottomSpace />
    </>
  )
}
